module.exports = __webpack_public_path__ + "static/media/land_bg.125021a9.svg";